export default "__VITE_ASSET__Bh1a425y__"